import React, { useEffect, useRef, useState } from 'react';

import Grid from '@mui/material/Grid';

import Typography from '@mui/material/Typography';

import TextField from '@mui/material/TextField';

import Button from '@mui/material/Button';

import FormControl from '@mui/material/FormControl';

import Alert from '@mui/material/Alert';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import DoNotDisturbOnIcon from '@mui/icons-material/DoNotDisturbOn';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';
import HealthAndSafetyOutlinedIcon from '@mui/icons-material/HealthAndSafetyOutlined';
import CloudUploadOutlinedIcon from '@mui/icons-material/CloudUploadOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

import './NewPatient.css';
import BrandedLoader from '../../../components/BrandedLoader/BrandedLoader';

import {
	getPayers,
	postAddPatientData,
	savefilepost,
	getLocation,
	PostAttahcmentFile,
	postAddPatientInsuranceData,
	postPatNotes,
	getPatInsById,
	moveToMaximusExport,
	getPracticeStaff,
} from '../../../services/api/apiManager';

import { states } from '../../../services/Settings';

import { DatePicker, DesktopDatePicker } from '@mui/x-date-pickers';

import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';

import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

import {
	Autocomplete,
	Badge,
	Box,
	Divider,
	IconButton,
	InputAdornment,
	InputLabel,
	MenuItem,
	Modal,
	Select,
	Snackbar,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Tooltip,
} from '@mui/material';

import { useNavigate } from 'react-router';

import { useStateValue } from '../../../services/state/State';

import * as Yup from 'yup';

import CancelIcon from '@mui/icons-material/Cancel';

import AddIcon from '@mui/icons-material/Add';

import CallIcon from '@mui/icons-material/Call';

import MaskedInput from 'react-text-mask';
import { DataGrid } from '@mui/x-data-grid';
import BorderColorIcon from '@mui/icons-material/BorderColor';
import DeleteIcon from '@mui/icons-material/Delete';
import { CircularProgress } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const formSectionSx = {
	backgroundColor: '#fff',
	backgroundClip: 'content-box',
	border: 'none',
	borderRadius: '8px',
	boxShadow: 'none',
	overflow: 'hidden',
	minHeight: '100%',
};

const formSectionHeaderSx = {
	padding: '10px 12px 6px',
	background: '#fff',
	display: 'flex',
	alignItems: 'center',
	gap: '10px',
};

const formSectionTitleSx = {
	fontSize: '16px',
	fontWeight: 700,
	fontFamily: 'Poppins',
	color: '#172d58',
};

const formBodySx = {
	padding: '6px 10px 10px',
};

const sectionIconSx = {
	width: 34,
	height: 34,
	borderRadius: '50%',
	backgroundColor: '#edf3ff',
	color: '#1f66ff',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	flexShrink: 0,
};

const addPatientPageSx = {
	width: '100%',
	maxWidth: '100%',
	boxSizing: 'border-box',
	overflowX: 'hidden',
	overflowY: 'auto',
	backgroundColor: '#f7f9fd',
	flex: 1,
	px: { xs: '10px', md: '16px' },

	'& .MuiTextField-root, & .MuiFormControl-root': {
		fontFamily: 'Poppins',
	},
	'& .MuiOutlinedInput-root': {
		borderRadius: '6px',
		backgroundColor: '#fff',
		fontFamily: 'Poppins',
		fontSize: '12px',
		color: '#172d58',
	},
	'& .MuiOutlinedInput-root:not(.MuiInputBase-multiline)': {
		height: '40px',
		minHeight: '40px',
	},
	'& .MuiOutlinedInput-root:not(.MuiInputBase-multiline) .MuiInputBase-input': {
		height: '40px',
		boxSizing: 'border-box',
		padding: '9px 12px',
	},
	'& .MuiSelect-select': {
		height: '40px !important',
		minHeight: '40px !important',
		boxSizing: 'border-box',
		display: 'flex',
		alignItems: 'center',
		padding: '9px 32px 9px 12px !important',
	},
	'& .MuiGrid-item > .MuiFormControl-root, & .MuiGrid-item > .MuiAutocomplete-root, & .MuiGrid-item > .MuiStack-root':
	{
		margin: '10px 0 0 !important',
	},
	'& .MuiGrid-item > .MuiFormControl-root:first-of-type, & .MuiGrid-item > .MuiAutocomplete-root:first-of-type, & .MuiGrid-item > .MuiStack-root:first-of-type':
	{
		marginTop: '6px !important',
	},
	'& .MuiOutlinedInput-notchedOutline': {
		borderColor: '#dde6f5',
	},
	'& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
		borderColor: '#c7d4e8',
	},
	'& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
		borderColor: '#2f6fd6',
		borderWidth: '1px',
	},
	'& .MuiInputLabel-root': {
		position: 'static',
		transform: 'none !important',
		fontFamily: 'Poppins',
		fontSize: '12px',
		fontWeight: 600,
		lineHeight: '16px',
		color: '#172d58',
		marginBottom: '6px',
		backgroundColor: 'transparent',
		padding: 0,
	},
	'& .MuiInputLabel-root .MuiBox-root': {
		lineHeight: '16px',
	},
	'& .MuiInputLabel-root.Mui-focused': {
		color: '#172d58',
	},
	'& .MuiInputLabel-asterisk': {
		color: '#ff2b2b',
	},
	'& .MuiOutlinedInput-notchedOutline': {
		top: 0,
		borderColor: '#dde6f5',
	},
	'& .MuiOutlinedInput-notchedOutline legend': {
		display: 'none',
	},
	'& .MuiInputBase-input::placeholder': {
		color: '#8b9ab5',
		opacity: 1,
	},
	'& .MuiFormHelperText-root': {
		fontFamily: 'Poppins',
		fontSize: '10px',
		marginLeft: 0,
	},
	'& .MuiStack-root': {
		paddingTop: '0 !important',
		overflow: 'visible',
		width: '100%',
		display: 'flex',
	},
	'& .MuiInputBase-multiline': {
		height: 'auto',
		minHeight: 'unset',
	},
	'& .MuiInputBase-multiline .MuiInputBase-input': {
		height: 'auto',
		padding: 0,
	},
	'& .MuiStack-root > .MuiBox-root': {
		width: '100%',
	},
	'& .MuiStack-root .MuiTextField-root': {
		width: '100%',
	},
	'& .MuiStack-root .MuiInputLabel-root': {
		position: 'static',
		transform: 'none !important',
	},
};

const renderFormSectionHeader = (icon, title) => (
	<Box sx={formSectionHeaderSx}>
		<Box sx={sectionIconSx}>{icon}</Box>
		<Typography sx={formSectionTitleSx}>{title}</Typography>
	</Box>
);

function NewPatient() {
	// for Save Button Disable
	const [addSave, setAddSave] = useState(false); // for Disabled Edit Save Button
	// Dispatch State Value
	const theme = useTheme();

	// Get Practice Id from Local Storage
	const practice_id = localStorage.getItem('practice_id');
	// Use Navigate Hook store in variable
	const darkNavigate = useNavigate();
	// Get Location from Location API State
	const [locationGet, setLocationGet] = React.useState([]);
	const [loadingLocation, setLoadingLocation] = React.useState(false); // for loading location data
	const [isLocationLoaded, setIsLocationLoaded] = React.useState(false);

	const [providers, setProviders] = useState([]); // Providers data state
	const [loadingProviders, setLoadingProviders] = useState(false); // Provider loading state
	const [isProviderLoaded, setIsProviderLoaded] = useState(false);

	// Get Insurance from Insurance API State
	const [insListName, setInsListName] = useState([]);
	const [loadingInsurance, setLoadingInsurance] = useState(false);
	const [isInsuranceLoaded, setIsInsuranceLoaded] = useState(false);
	// Snackbar Open State if textfield posted
	const [openSnackbar, setOpenSnackbar] = useState(false);
	// Snackbar Open State if textfield empty
	const [openEmptySnackbar, setOpenEmptySnackbar] = useState(false);
	// Snackbar Open State if textfield empty
	const [openValidateSnackbar, setOpenValidateSnackbar] = useState(false);
	// Snackbar Open State if patient already exist
	const [openPatAlreadyExistSnackbar, setOpenPatAlreadyExistSnackbar] =
		useState(false);
	//  Error Validation State
	const [errors, setErrors] = useState({});
	// Pagination States here
	const [changePage, setChangePage] = useState({
		in_Page_Number: 0,
		in_Rows: 100,
	});
	const [paginationModel, setPaginationModel] = React.useState({
		page: 0,
		pageSize: 5,
	});
	// Loading State
	const [loading, setLoading] = useState(false);
	const fileInputRef = useRef(null);
	const [duplicateModalOpen, setDuplicateModalOpen] = useState(false);
	const [selectedFiles, setSelectedFiles] = useState([]);
	const [insErrors, setInsErrors] = useState([]);
	const [insuranceForms, setInsuranceForms] = useState([]);
	const handleAddInsuranceForm = () => {
		setInsuranceForms((prev) => [
			...prev,
			{
				planName: '',
				insuranceName: '',
				policyNo: '',
				groupName: '',
			},
		]);
	};
	const handleCloseInsuranceForm = (indexNo) => {
		const removerForm = insuranceForms?.filter((items, index) => {
			return index != indexNo;
		});
		setInsuranceForms(removerForm);

		// Remove corresponding error at that index
		setInsErrors((prevErrors) => {
			const updatedErrors = [...prevErrors];
			updatedErrors.splice(indexNo, 1);
			return updatedErrors;
		});
	};

	// fucntion for getting patient insurance data By Id
	const [allInsuranceData, setAllInsuranceData] = useState([]);

	const getInsData = async (patientID) => {
		const resp = await getPatInsById(patientID);
		if (resp?.status === 200) {
			setPatientStates({
				fname: '',
				lname: '',
				dob: null,
				mrn: '',
				adm: null,
				room: '',
				bedNo: '',
				gender: '',
				provider: '',
				refphy: '',
				dischargeDate: null,
				location: '',
				contact: '',
				cnotes: '',
				pname: '',
				iname: '',
				policy: '',
				gname: '',
				address: '',
				cc: '',
				ccr: '',
				con: '',
				city: '',
				state: '',
				zip: '',
			});
			setSelectedFiles([]);
			setInsuranceForms([]);
			// setResPatInsurance(resp);
			// setIdOfInsData(resp?.data?.patient_insurances[0]?.id);
			// setInsIds(resp?.data?.patient_insurances?.slice(1)?.map((i) => i?.id));
			// setAllInsIds(resp?.data?.patient_insurances?.map((i) => i?.id));
			// setPatientStates((prevState) => ({
			// 	...prevState,
			// 	policy: resp?.data?.patient_insurances[0]?.PolicyNumber,
			// 	gname: resp?.data?.patient_insurances[0]?.GroupName,
			// 	pname: resp?.data?.patient_insurances[0]?.PlanName,
			// 	iname: resp?.data?.patient_insurances[0]?.payer_id,
			// }));
			const allInsuranceData = resp?.data?.patient_insurances || [];

			// All insurance forms
			const InsuranceData = allInsuranceData?.map((item, index) => ({
				id: index + 1,
				planName: item?.PlanName || '',
				insuranceName: item?.payer_id || '',
				policyNo: item?.PolicyNumber || '',
				groupName: item?.GroupName || '',
				action: 'put',
			}));
			setAllInsuranceData(InsuranceData);

			// Remaining insurance forms (from index 1 onwards)
			// const otherInsuranceData = allInsuranceData?.slice(1)?.map((item) => ({
			// 	planName: item?.PlanName || '',
			// 	insuranceName: item?.payer_id || '',
			// 	policyNo: item?.PolicyNumber || '',
			// 	groupName: item?.GroupName || '',
			// 	action: 'put',
			// }));
			// setInsuranceForms(otherInsuranceData);
		}
	};

	// const [dublicateFileSnack, setDublicateFileSnack] = React.useState(false);

	// const maxDate = new Date();
	// maxDate.setMonth(maxDate.getMonth() + 1);

	// All Patient Text Fields states here
	const [patientStates, setPatientStates] = useState({
		fname: '',
		lname: '',
		dob: null,
		mrn: '',
		adm: null,
		room: '',
		bedNo: '',
		gender: '',
		provider: '',
		refphy: '',
		dischargeDate: null,
		location: '',
		contact: '',
		cnotes: '',
		pname: '',
		iname: '',
		policy: '',
		gname: '',
		address: '',
		cc: '',
		ccr: '',
		con: '',
		city: '',
		state: '',
		zip: '',
	});

	const isFilled = (value) => {
		if (value == null) return false;
		const digitCount = (value.match(/\d/g) || [])?.length;
		return digitCount === 10;
	};

	const handleChangePatientStates = (e) => {
		// const { name, value } = e.target;
		// setPatientStates((prev) => {
		// 	return { ...prev, [name]: value };
		// });
		if (e?.target) {
			const { name, value } = e.target;
			setPatientStates((prev) => ({
				...prev,
				[name]: value,
			}));
		} else {
			setPatientStates((prev) => ({
				...prev,
				state: e,
			}));
		}
	};

	const handleDateOfBirthChange = (date) => {
		setPatientStates((prev) => {
			return { ...prev, dob: date };
		});
	};

	const handleAdmissionDateChange = (date) => {
		setPatientStates((prev) => {
			return { ...prev, adm: date };
		});
	};

	const handleDischargeDateChange = (date) => {
		setPatientStates((prev) => {
			return { ...prev, dischargeDate: date };
		});
	};

	const schema = Yup.object().shape({
		// Section of Alphabets only
		fname: Yup.string()
			.matches(/^[a-zA-Z]+$/, 'No spaces or special characters are allowed')
			.required('First Name is required'),
		lname: Yup.string()
			.matches(/^[a-zA-Z]+$/, 'No spaces or special characters are allowed')
			.required('Last Name is required'),
		// cnotes: Yup.string().test('alphabets-only', 'Alphabets only', (value) => {
		// 	return !value || /^[a-zA-Z\s]+$/.test(value);
		// }),
		pname: Yup.string().test('alphabets-only', 'Alphabets only', (value) => {
			return !value || /^[a-zA-Z\s]+$/.test(value);
		}),
		gname: Yup.string().test('alphabets-only', 'Alphabets only', (value) => {
			return !value || /^[a-zA-Z\s]+$/.test(value);
		}),
		// address: Yup.string().test(
		// 	'alphabets-numbers-only',
		// 	'Alphabets & numbers only',
		// 	(value) => {
		// 		return !value || /^[a-zA-Z0-9,\s]+$/.test(value);
		// 	}
		// ),
		cc: Yup.string().test('alphabets-only', 'Alphabets only', (value) => {
			return !value || /^[a-zA-Z\s]+$/.test(value);
		}),
		ccr: Yup.string().test('alphabets-only', 'Alphabets only', (value) => {
			return !value || /^[a-zA-Z\s]+$/.test(value);
		}),
		city: Yup.string().test('alphabets-only', 'Alphabets only', (value) => {
			return !value || /^[a-zA-Z\s]+$/.test(value);
		}),
		state: Yup.string().test('alphabets-only', 'Alphabets only', (value) => {
			return !value || /^[a-zA-Z\s]+$/.test(value);
		}),
		// Section of Numbers only
		room: Yup.string().test(
			'alphabets-numbers-only',
			'Alphabets & numbers only',
			(value) => {
				return !value || /^[a-zA-Z0-9,\s]+$/.test(value);
			}
		),
		bedNo: Yup.string().test(
			'alphabets-numbers-only',
			'Alphabets & numbers only',
			(value) => {
				return !value || /^[a-zA-Z0-9,\s]+$/.test(value);
			}
		),
		policy: Yup.string().test(
			'alphanumeric-only',
			'Alphanumeric characters only',
			(value) => {
				return !value || /^[a-zA-Z0-9]+$/.test(value);
			}
		),
		zip: Yup.string().test('numbers-only', 'Numbers only', (value) => {
			return !value || /^\d+$/.test(value);
		}),
		mrn: Yup.string()
			.max(10, 'MRN must not exceed 10 characters')
			.test(
				'alphabets-numbers-only',
				'Only alphabets and numbers are allowed',
				(value) => !value || /^[a-zA-Z0-9]+$/.test(value)
			),
		// Section of Contact Number only
		contact: Yup.string().test('contact-format', 'Invalid', (value) => {
			return (
				!value ||
				/^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/.test(value)
			);
		}),
		con: Yup.string().test('contact-format', 'Invalid', (value) => {
			return (
				!value ||
				/^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/.test(value)
			);
		}),
		dob: Yup.date().required('Date of birth is required'),
		adm: Yup.date().required('Admission date is required'),
		dischargeDate: Yup.date().required('Discharge Date is required'),
	});
	const singleInsuranceSchema = Yup.object().shape({
		planName: Yup.string().test('alphabets-only', 'Alphabets only', (value) => {
			return !value || /^[a-zA-Z\s]+$/.test(value);
		}),

		groupName: Yup.string().test(
			'alphabets-only',
			'Alphabets only',
			(value) => {
				return !value || /^[a-zA-Z\s]+$/.test(value);
			}
		),

		policyNo: Yup.string().test(
			'alphanumeric-only',
			'Alphanumeric characters only',
			(value) => {
				return !value || /^[a-zA-Z0-9]+$/.test(value);
			}
		),
	});

	// Convert Date of Birth into string format
	const year = new Date(patientStates?.dob).getFullYear();
	const month = (new Date(patientStates?.dob).getMonth() + 1)
		.toString()
		.padStart(2, '0');
	const day = new Date(patientStates?.dob)
		.getDate()
		.toString()
		.padStart(2, '0');
	const formattedDate = `${year}-${month}-${day}`;

	// Convert Admission Date into string format
	const year2 = new Date(patientStates?.adm).getFullYear();
	const month2 = (new Date(patientStates?.adm).getMonth() + 1)
		.toString()
		.padStart(2, '0');
	const day2 = new Date(patientStates?.adm)
		.getDate()
		.toString()
		.padStart(2, '0');
	const admDate = `${year2}-${month2}-${day2}`;

	// Convert Discharge Date into string format
	const year3 = new Date(patientStates?.dischargeDate).getFullYear();
	const month3 = (new Date(patientStates?.dischargeDate).getMonth() + 1)
		.toString()
		.padStart(2, '0');
	const day3 = new Date(patientStates?.dischargeDate)
		.getDate()
		.toString()
		.padStart(2, '0');
	const dischargeDate = `${year3}-${month3}-${day3}`;

	// Snackbar Open if textfield empty function

	const ShowEmptySnackbar = () => {
		setOpenEmptySnackbar(true);
	};
	const CancelEmptySnackbar = () => {
		setOpenEmptySnackbar(false);
		setOpenPatAlreadyExistSnackbar(false);
	};

	// Snackbar Open if textfield filled for posted Data

	const handleCloseSnackbar = () => {
		setOpenSnackbar(false);
	};
	const notes_PatientUpdateInformation = async (data) => {
		try {
			const response = await postPatNotes(data);
			console.log('Status check:', response);
		} catch (error) {
			console.error('Error:', error);
		}
	};
	// Post Patient Data & Patient Admission Data store on variable
	const PatientData = {
		practice_id: practice_id,
		Fname: patientStates?.fname,
		Lname: patientStates?.lname,
		...(patientStates?.dob && {
			DOB: formattedDate,
		}),
		// DOB: `${formattedDate}`,
		Gender: patientStates?.gender,
		Contact: patientStates?.contact,
		Address: patientStates?.address,
		City: patientStates?.city,
		State: patientStates?.state,
		Zip: patientStates?.zip,
		MRN: patientStates?.mrn,
		ClinicalNotes: patientStates?.cnotes,
		CareCoordinator: patientStates?.cc,
		CCContact: patientStates?.con,
		CCRelation: patientStates?.ccr,
		Deleted: false,
		Inactive: patientStates?.dischargeDate != null ? true : false,
		patient_admissions: [
			{
				practice_id: practice_id,
				...(patientStates?.refphy && {
					refphy_id: patientStates?.refphy,
				}),
				...(patientStates?.provider && {
					provider_id: patientStates?.provider,
				}),
				...(patientStates?.location && {
					location_id: patientStates?.location,
				}),
				...(patientStates?.adm && {
					Admission_date: admDate,
				}),
				// Admission_date: `${admDate}`,
				discharge_date:
					patientStates?.dischargeDate !== null ? `${dischargeDate}` : null,
				Bed_No: patientStates?.bedNo,
				Room_No: patientStates?.room,
				Deleted: false,
			},
		],
	};
	const OSW_id = localStorage.getItem('OSW_id');
	const moveToMaximusData = {
		OSW_id: OSW_id,
		visitids: '',
		practice_id: practice_id,
		patient_id: '',
	};
	const buttonSubmit = async (e) => {
		e.preventDefault();
		setAddSave(true);

		if (patientStates?.fname === '' || patientStates?.lname === '') {
			ShowEmptySnackbar();
			setTimeout(() => {
				setOpenSnackbar(false);
				setAddSave(false);
			}, 2500);
		} else if (errors.fname || errors.lname || errors.mrn) {
			setOpenValidateSnackbar(true);
			setTimeout(() => {
				setOpenValidateSnackbar(false);
				setAddSave(false);
			}, 1500);
		} else {
			if (patientStates?.iname !== '' && patientStates?.policy === '') {
				ShowEmptySnackbar();
				setTimeout(() => {
					setOpenSnackbar(false);
					setAddSave(false);
				}, 1500);
			} else {
				const resp = await postAddPatientData({
					...PatientData,
				});

				if (resp?.request?.status === 200) {
					const dupflag = 'true';
					setDuplicateModalOpen(true);
					setAddSave(false);
				} else if (resp?.status === 201 || resp?.status === 200) {
					if (resp?.status === 200 || resp?.status === 201) {
						if (OSW_id == '1') {
							moveToMaximusData.patient_id = resp?.data?.id;
							const resMaximus = await moveToMaximusExport(moveToMaximusData);
							console.log('res:', resMaximus);
						}
						const patientId = resp?.data?.id;
						getInsData(resp?.data?.id);

						// for Add single insurance if exists
						if (patientStates?.iname !== '') {
							const patientInsuranceData = {
								patient_id: patientId,
								...(patientStates?.policy && {
									PolicyNumber: patientStates?.policy,
								}),
								...(patientStates?.pname && { PlanName: patientStates?.pname }),
								...(patientStates?.gname && {
									GroupName: patientStates?.gname,
								}),
								...(patientStates?.iname && { payer_id: patientStates?.iname }),
								Type: 'P',
								Deleted: false,
							};

							await postAddPatientInsuranceData(patientInsuranceData);
						}

						// for Add multiple insurance forms
						if (insuranceForms?.length > 0) {
							let invalidFound = false;

							for (const item of insuranceForms) {
								const insuranceObj = {
									...(item?.planName && { PlanName: item?.planName }),
									...(item?.groupName && { GroupName: item?.groupName }),
									...(item?.policyNo && { PolicyNumber: item?.policyNo }),
									...(item?.insuranceName && { payer_id: item?.insuranceName }),
									patient_id: patientId,
									Type: 'P',
									Deleted: false,
								};

								// Send only if all fields are filled
								if (insuranceObj?.PolicyNumber && insuranceObj?.payer_id) {
									await postAddPatientInsuranceData(insuranceObj);
								} else {
									invalidFound = true;
								}
							}
						}
					}

					const notesData = {
						Patientid: resp?.data?.id,
						Visit_id: null,
						practice_id: practice_id,
						NoteCategory: 'patient',
						Platform: 'web',
						Notes: [{ NotesText: 'New patient created successfully.' }],
					};

					try {
						await notes_PatientUpdateInformation(notesData);
					} catch (error) {
						console.error('Error posting notes:', error);
					}

					for (const i of selectedFiles) {
						if (i) {
							const formData = new FormData();
							formData.append('file', i);
							formData.append('filepath', practice_id + '/' + resp?.data?.id);

							try {
								const savefile = await savefilepost(formData);
								const storeFileName = savefile?.data?.file_name;
								const storeFilePath = savefile?.data?.file_path;

								const AttachmentFilePost = {
									patient_id: resp?.data?.id,
									AttachmentName: storeFileName,
									Path: storeFilePath,
									Type: i?.type,
								};

								await PostAttahcmentFile(AttachmentFilePost);
							} catch (error) {
								console.error('Error uploading file:', error);
							}
						}
					}

					setOpenSnackbar(true);
					setTimeout(() => {
						setOpenSnackbar(false);
						darkNavigate('/patient_list');
						setAddSave(false);
					}, 1500);
					setLoading(false);
				}
			}
		}
	};
	// const handleDuplicateConfirm = async () => {
	// 	setDuplicateModalOpen(false);
	// 	setAddSave(true);

	// 	const resp = await postAddPatientData({ ...PatientData, dupflag: true });
	// 	if (resp?.status === 201 || resp?.status === 200) {
	// 		setOpenSnackbar(true);
	// 		setTimeout(() => {
	// 			setOpenSnackbar(false);
	// 			darkNavigate('/patient_list');
	// 			setAddSave(false);
	// 		}, 1500);
	// 	}
	// };
	const handleDuplicateConfirm = async () => {
		setDuplicateModalOpen(false);
		setAddSave(true);
		const resp = await postAddPatientData({ ...PatientData, dupflag: true });
		if (resp?.status === 201 || resp?.status === 200) {
			const notesData = {
				Patientid: resp?.data?.id,
				Visit_id: null,
				practice_id: practice_id,
				NoteCategory: 'patient',
				Platform: 'web',
				Notes: [{ NotesText: 'New patient created successfully.' }],
			};
			try {
				await notes_PatientUpdateInformation(notesData);
			} catch (error) {
				console.error('Error posting notes:', error);
			}
			setOpenSnackbar(true);
			setTimeout(() => {
				setOpenSnackbar(false);
				darkNavigate('/patient_list');
				setAddSave(false);
			}, 1500);
		} else {
			setAddSave(false);
		}
	};

	// Get Provider
	const showPracticeData = async () => {
		if (loadingProviders || isProviderLoaded) return;

		setLoadingProviders(true);

		try {
			const response = await getPracticeStaff();

			if (response?.status === 200) {
				setProviders(response?.data || []);
			} else {
				setProviders([]);
			}

			setIsProviderLoaded(true);
		} catch (error) {
			setProviders([]);
		} finally {
			setLoadingProviders(false);
		}
	};

	// get Payer (Insurance) from API
	const showPayerName = async () => {
		if (loadingInsurance || isInsuranceLoaded) return;

		setLoadingInsurance(true);

		try {
			const resp = await getPayers();

			if (resp?.status === 200) {
				setInsListName(resp?.data || []);
			} else {
				setInsListName([]);
			}

			setIsInsuranceLoaded(true);
		} catch (error) {
			setInsListName([]);
		} finally {
			setLoadingInsurance(false);
		}
	};
	// Get Location from Location API function
	const getLocationData = async () => {
		if (loadingLocation || isLocationLoaded) return;

		setLoadingLocation(true);

		try {
			const resp = await getLocation();
			setLocationGet(resp?.data || []);
			setIsLocationLoaded(true);
		} catch (error) {
			setLocationGet([]);
		} finally {
			setLoadingLocation(false);
		}
	};
	const handleAttachmentFiles = (files) => {
		const incomingFiles = Array.from(files || []);
		const newFileNames = incomingFiles?.map((file) => file?.name);

		setSelectedFiles((prevSelectedFiles) => {
			const existingFileNames = new Set(
				prevSelectedFiles?.map((file) => file?.name)
			);
			const duplicateInNewFiles = newFileNames.some(
				(name, index) => newFileNames.indexOf(name) !== index
			);
			const duplicatesWithExisting = newFileNames.every((name) =>
				existingFileNames.has(name)
			);

			if (duplicateInNewFiles || duplicatesWithExisting) {
				return prevSelectedFiles;
			}

			return [...prevSelectedFiles, ...incomingFiles];
		});
	};
	const handleFileRemove = (fileToRemove) => {
		setSelectedFiles((prevFiles) =>
			prevFiles.filter((file) => file !== fileToRemove)
		);
		if (fileInputRef.current) {
			fileInputRef.current.value = [];
		}
	};
	// handle Provider Dropdown Open
	const handleProviderDropdownOpen = () => {
		if (!isProviderLoaded) {
			showPracticeData();
		}
	};

	// handle Insurance Dropdown Open
	const handleInsuranceDropdownOpen = () => {
		if (!isInsuranceLoaded) {
			showPayerName();
		}
	};

	// Data Grid Table Info...

	const InsuranceColumn = [
		{
			field: 'id',
			headerName: 'Sr.No',
			flex: 0.8,
			minWidth: 20,
		},
		{
			field: 'planName',
			headerName: 'Plan',
			flex: 1,
			minWidth: 70,
		},
		{
			field: 'insuranceName',
			headerName: 'Insurance',
			flex: 1,
			minWidth: 120,
			valueGetter: (params) => {
				const id = params?.row?.insuranceName;
				const match = insListName?.find((x) => x.id === id);
				return match ? match.Name : '';
			},
		},
		{
			field: 'groupName',
			headerName: 'Group',
			flex: 1,
			minWidth: 50,
		},
		{
			field: 'policyNo',
			headerName: 'Policy',
			flex: 0.5,
			minWidth: 80,
		},
		// {
		// 	field: 'actions',
		// 	headerName: 'Actions',
		// 	sortable: false,
		// 	filterable: false,
		// 	flex: 0.5,
		// 	minWidth: 90,
		// 	renderCell: (params) => {
		// 		// const currentId = allInsIds[params?.id - 1];
		// 		return (
		// 			<Box sx={{ display: 'flex', gap: 1 }}>
		// 				<Tooltip title="Edit" placement="left">
		// 					<IconButton
		// 						color="primary"
		// 						onClick={() => {
		// 							console.log('Edit', params?.row);
		// 						}}
		// 						size="small"
		// 						sx={{ color: '#0D406F' }}
		// 					>
		// 						<BorderColorIcon fontSize="small" />
		// 					</IconButton>
		// 				</Tooltip>
		// 				<Tooltip title="Delete" placement="top-end">
		// 					<IconButton
		// 						color="error"
		// 						onClick={() => {
		// 							console.log('Delete', params?.row);
		// 						}}
		// 						size="small"
		// 						sx={{ color: '#ED2828' }}
		// 					>
		// 						<DeleteIcon fontSize="small" />
		// 					</IconButton>
		// 				</Tooltip>
		// 			</Box>
		// 		);
		// 	},
		// },
	];

	return (
		<>
			<Box sx={addPatientPageSx}>
				{loading ? (
					<BrandedLoader
						title="Loading patient form"
						text="Preparing patient details"
					/>
				) : (
					<>
						<Box
							sx={{
								width: '100%',
								boxSizing: 'border-box',
								px: 0,
								pt: 0,
							}}
						>
							<Grid
								container
								spacing={2}
								sx={{ alignItems: 'stretch', m: 0, width: '100%' }}
							>
								{/* Patient Info */}
								<Grid
									item
									xl={4}
									lg={4}
									md={12}
									sm={12}
									xs={12}
									sx={formSectionSx}
								>
									{renderFormSectionHeader(
										<PersonOutlineOutlinedIcon fontSize="small" />,
										'Patient Information'
									)}
									<Grid
										container
										item
										columnSpacing={1}
										rowSpacing={1}
										sx={formBodySx}
									>
										<Grid item xl={6} lg={6} md={6} sm={6} xs={6}>
											<TextField
												sx={{
													marginTop: '.5rem',
													marginBottom: '.5rem',
													'& .MuiInputLabel-asterisk': {
														color: 'red',
													},
												}}
												fullWidth
												size="small"
												name="fname"
												// onChange={(e) => {
												// 	handleChangePatientStates(e);
												// 	Yup.reach(schema, 'fname')
												// 		.validate(e.target.value)
												// 		.then(() => {
												// 			setErrors((prevErrors) => ({
												// 				...prevErrors,
												// 				fname: '',
												// 			}));
												// 		})
												// 		.catch((error) => {
												// 			setErrors((prevErrors) => ({
												// 				...prevErrors,
												// 				fname: error.message,
												// 			}));
												// 		});
												// }}
												value={patientStates?.fname}
												onChange={(e) => {
													handleChangePatientStates(e);
													Yup.reach(schema, 'fname')
														.validate(e.target.value)
														.then(() => {
															setErrors((prevErrors) => ({
																...prevErrors,
																fname: '',
															}));
														})
														.catch((error) => {
															setErrors((prevErrors) => ({
																...prevErrors,
																fname: error.message,
															}));
														});
												}}
												required
												label="First Name"
												placeholder="Enter first name"
												variant="outlined"
												id="outlined-basic"
												autoComplete="off"
											/>
											{errors.fname && (
												<div
													style={{
														color: 'red',
														fontSize: '10px',
														marginTop: '-7px',
														marginBottom: '8px',
													}}
												>
													{errors.fname}
												</div>
											)}
											<LocalizationProvider dateAdapter={AdapterDayjs}>
												<DemoContainer
													components={['DatePicker', 'DesktopDatePicker']}
												>
													<DemoItem>
														<DatePicker
															size="small"
															slotProps={{
																textField: {
																	size: 'small',
																	placeholder: 'Select date',
																},
															}}
															// disableFuture={true}
															label={
																<Box
																	sx={{ display: 'flex', alignItems: 'center' }}
																>
																	DOB
																	{/* <Box
																	component="span"
																	sx={{ color: 'red', marginLeft: '2px' }}
																>
																	*
																</Box> */}
																</Box>
															}
															sx={{
																width: '100%',
															}}
															name="dob"
															value={patientStates?.dob}
															onChange={(e) => {
																handleDateOfBirthChange(e);
																Yup.reach(schema, 'dob')
																	.validate(e)
																	.then(() => {
																		setErrors((prevErrors) => ({
																			...prevErrors,
																			dob: '',
																		}));
																	})
																	.catch((error) => {
																		setErrors((prevErrors) => ({
																			...prevErrors,
																			dob: error.message,
																		}));
																	});
															}}
														/>
													</DemoItem>
												</DemoContainer>
											</LocalizationProvider>
											{/* {errors.dob && (
											<div style={{ color: 'red', fontSize: '10px' }}>
												{errors.dob}
											</div>
										)} */}
											<TextField
												sx={{
													marginTop: '1rem',
												}}
												fullWidth
												size="small"
												name="contact"
												value={patientStates?.contact}
												onChange={(e) => {
													handleChangePatientStates(e);
												}}
												InputProps={{
													endAdornment: (
														<InputAdornment position="start">
															<CallIcon sx={{ color: '#DDE6F1' }} />
														</InputAdornment>
													),
													inputComponent: MaskedInput,
													inputProps: {
														mask: [
															'(',
															/\d/,
															/\d/,
															/\d/,
															')',
															' ',
															/\d/,
															/\d/,
															/\d/,
															'-',
															/\d/,
															/\d/,
															/\d/,
															/\d/,
														],
													},
													sx: {
														borderRadius: '3px',
														height: '40px',
														'& .MuiOutlinedInput-input': {
															padding: '5px 0px 5px 6px',
														},
													},
												}}
												error={
													patientStates?.contact != '' &&
													!isFilled(patientStates?.contact)
												}
												helperText={
													patientStates?.contact != '' &&
														!isFilled(patientStates?.contact)
														? 'Please enter a valid phone number'
														: ''
												}
												label="Contact#"
												placeholder="Enter contact number"
												variant="outlined"
												autoComplete="off"
											/>
											{errors.contact && (
												<div style={{ color: 'red', fontSize: '10px' }}>
													{errors.contact}
												</div>
											)}
											<TextField
												sx={{
													marginTop: '1rem',
													marginBottom: '.5rem',
												}}
												fullWidth
												size="small"
												name="room"
												value={patientStates?.room}
												onChange={(e) => {
													handleChangePatientStates(e);
													Yup.reach(schema, 'room')
														.validate(e.target.value)
														.then(() => {
															setErrors((prevErrors) => ({
																...prevErrors,
																room: '',
															}));
														})
														.catch((error) => {
															setErrors((prevErrors) => ({
																...prevErrors,
																room: error.message,
															}));
														});
												}}
												label="Room#"
												placeholder="Enter room number"
												variant="outlined"
												autoComplete="off"
											/>
											{/* {errors.room && (
											<div style={{ color: 'red', fontSize: '10px' }}>
												{errors.room}
											</div>
										)} */}
											<LocalizationProvider dateAdapter={AdapterDayjs}>
												<DemoContainer
													components={['DatePicker', 'DesktopDatePicker']}
												>
													<DemoItem>
														<DesktopDatePicker
															// disableFuture
															size="small"
															slotProps={{
																textField: {
																	size: 'small',
																	placeholder: 'Select date',
																	InputLabelProps: {
																		sx: {
																			fontSize: {
																				lg: '16px',
																				md: '13px',
																				sm: '16px',
																				xs: '16px',
																			},
																		},
																	},
																},
															}}
															sx={{
																width: '100%',
															}}
															name="adm"
															label={
																<Box
																	sx={{ display: 'flex', alignItems: 'center' }}
																>
																	Adm Date
																	{/* <Box
																	component="span"
																	sx={{ color: 'red', marginLeft: '2px' }}
																>
																	*
																</Box> */}
																</Box>
															}
															value={patientStates?.adm}
															onChange={(e) => {
																handleAdmissionDateChange(e);
																Yup.reach(schema, 'adm')
																	.validate(e)
																	.then(() => {
																		setErrors((prevErrors) => ({
																			...prevErrors,
																			adm: '',
																		}));
																	})
																	.catch((error) => {
																		setErrors((prevErrors) => ({
																			...prevErrors,
																			adm: error.message,
																		}));
																	});
															}}
														/>
													</DemoItem>
												</DemoContainer>
											</LocalizationProvider>
											{/* {errors.adm && (
											<div style={{ color: 'red', fontSize: '10px' }}>
												{errors.adm}
											</div>
										)} */}
											<Autocomplete
												size="small"
												id="provider-autocomplete"
												options={providers || []}
												getOptionLabel={(option) =>
													option ? `${option?.Lname}, ${option?.Fname}` : ''
												}
												sx={{ mt: 2 }}
												value={
													providers?.find(
														(item) => item?.id === patientStates?.provider
													) || null
												}
												onChange={(event, newValue) => {
													handleChangePatientStates({
														target: {
															name: 'provider',
															value: newValue ? newValue?.id : '',
														},
													});
												}}
												loading={loadingProviders}
												onOpen={handleProviderDropdownOpen}
												noOptionsText={
													loadingProviders ? (
														<Box
															display="flex"
															alignItems="center"
															gap={1}
															p={1}
														>
															<CircularProgress size={16} />
															<Typography fontSize={12}>Loading...</Typography>
														</Box>
													) : (
														'No options'
													)
												}
												ListboxProps={{
													style: {
														maxHeight: '160px',
													},
												}}
												renderInput={(params) => (
													<TextField
														{...params}
														label="Provider"
														placeholder="Select provider"
														variant="outlined"
														error={errors.provider}
														helperText={errors.provider}
														sx={{
															'& .MuiOutlinedInput-root': {
																'&.Mui-focused fieldset': {
																	borderColor: '#0E6368',
																},
															},
														}}
													/>
												)}
											/>
											<TextField
												sx={{
													marginTop: '1rem',
												}}
												fullWidth
												size="small"
												name="address"
												autoComplete="off"
												value={patientStates?.address}
												onChange={(e) => {
													handleChangePatientStates(e);
													// Yup.reach(schema, 'address')
													// 	.validate(e.target.value)
													// 	.then(() => {
													// 		setErrors((prevErrors) => ({
													// 			...prevErrors,
													// 			address: '',
													// 		}));
													// 	})
													// 	.catch((error) => {
													// 		setErrors((prevErrors) => ({
													// 			...prevErrors,
													// 			address: error.message,
													// 		}));
													// 	});
												}}
												label="Address"
												placeholder="Enter address"
												variant="outlined"
											/>
											{errors?.address && (
												<div style={{ color: 'red', fontSize: '10px' }}>
													{errors?.address}
												</div>
											)}
										</Grid>
										<Grid item xs={6}>
											<TextField
												sx={{
													marginTop: '.5rem',
													marginBottom: '1rem',
													'& .MuiInputLabel-asterisk': {
														color: 'red',
													},
												}}
												fullWidth
												size="small"
												name="lname"
												value={patientStates?.lname}
												onChange={(e) => {
													handleChangePatientStates(e);
													Yup.reach(schema, 'lname')
														.validate(e.target.value)
														.then(() => {
															setErrors((prevErrors) => ({
																...prevErrors,
																lname: '',
															}));
														})
														.catch((error) => {
															setErrors((prevErrors) => ({
																...prevErrors,
																lname: error.message,
															}));
														});
												}}
												required
												label="Last Name"
												placeholder="Enter last name"
												variant="outlined"
												autoComplete="off"
											/>
											{errors.lname && (
												<div
													style={{
														color: 'red',
														fontSize: '10px',
														marginTop: '-7px',
														marginBottom: '8px',
													}}
												>
													{errors.lname}
												</div>
											)}
											<FormControl fullWidth size="small">
												<InputLabel id="demo-simple-select-label">
													Gender
												</InputLabel>
												<Select
													value={patientStates?.gender}
													name="gender"
													onChange={(e) => {
														handleChangePatientStates(e);
													}}
													label="Gender"
													inputProps={{ 'aria-label': 'Without label' }}
												>
													<MenuItem value="M">Male</MenuItem>
													<MenuItem value="F">Female</MenuItem>
													<MenuItem value="O">Other</MenuItem>
												</Select>
											</FormControl>
											<TextField
												sx={{
													marginTop: '1rem',
												}}
												fullWidth
												size="small"
												name="mrn"
												autoComplete="off"
												value={patientStates?.mrn}
												onChange={(e) => {
													handleChangePatientStates(e);
													Yup.reach(schema, 'mrn')
														.validate(e.target.value)
														.then(() => {
															setErrors((prevErrors) => ({
																...prevErrors,
																mrn: '',
															}));
														})
														.catch((error) => {
															setErrors((prevErrors) => ({
																...prevErrors,
																mrn: error.message,
															}));
														});
												}}
												label="MRN"
												placeholder="Enter MRN"
												variant="outlined"
											/>
											{errors.mrn && (
												<div style={{ color: 'red', fontSize: '10px' }}>
													{errors.mrn}
												</div>
											)}
											<TextField
												sx={{
													marginTop: '1rem',
													marginBottom: '.5rem',
												}}
												fullWidth
												size="small"
												name="bedNo"
												autoComplete="off"
												value={patientStates?.bedNo}
												onChange={(e) => {
													handleChangePatientStates(e);
													Yup.reach(schema, 'bedNo')
														.validate(e.target.value)
														.then(() => {
															setErrors((prevErrors) => ({
																...prevErrors,
																bedNo: '',
															}));
														})
														.catch((error) => {
															setErrors((prevErrors) => ({
																...prevErrors,
																bedNo: error.message,
															}));
														});
												}}
												label="Bed No"
												placeholder="Enter bed number"
												variant="outlined"
											/>
											{/* {errors.bedNo && (
											<div style={{ color: 'red', fontSize: '10px' }}>
												{errors.bedNo}
											</div>
										)}{' '} */}
											<LocalizationProvider dateAdapter={AdapterDayjs}>
												<DemoContainer
													components={['DatePicker', 'DesktopDatePicker']}
												>
													<DemoItem>
														<DesktopDatePicker
															size="small"
															slotProps={{
																textField: {
																	size: 'small',
																	placeholder: 'Select date',
																	InputLabelProps: {
																		sx: {
																			fontSize: {
																				lg: '16px',
																				md: '13px',
																				sm: '16px',
																				xs: '16px',
																			},
																			textAlign: 'center',
																		},
																	},
																},
															}}
															sx={{
																width: '100%',
															}}
															name="dischargeDate"
															label={
																<Box
																	sx={{ display: 'flex', alignItems: 'center' }}
																>
																	Discharge On
																</Box>
															}
															value={patientStates?.dischargeDate}
															disabled={!patientStates?.adm}
															// minDate={patientStates?.adm}
															onChange={(e) => {
																handleDischargeDateChange(e);
																Yup.reach(schema, 'dischargeDate')
																	.validate(e)
																	.then(() => {
																		setErrors((prevErrors) => ({
																			...prevErrors,
																			dischargeDate: '',
																		}));
																	})
																	.catch((error) => {
																		setErrors((prevErrors) => ({
																			...prevErrors,
																			dischargeDate: error.message,
																		}));
																	});
															}}
														/>
													</DemoItem>
												</DemoContainer>
											</LocalizationProvider>
											{/* {errors.dischargeDate && (
											<div style={{ color: 'red', fontSize: '10px' }}>
												{errors.dischargeDate}
											</div>
										)} */}

											{/* Ref Phy */}
											{/* <FormControl
											fullWidth
											size="small"
											sx={{
												marginTop: '1rem',
											}}
										>
											<InputLabel id="demo-simple-select-label">
												Ref Phy
											</InputLabel>
											<Select
												value={patientStates?.refphy}
												name="refphy"
												onChange={(e) => {
													handleChangePatientStates(e);
												}}
												MenuProps={{
													PaperProps: {
														style: {
															maxHeight: '200px',
															width: '130px',
															overflowY: 'auto',
															overflowX: 'auto',
															scrollbarWidth: 'thin',
															scrollbarColor: 'dark',
															msOverflowStyle: 'none',
															WebkitOverflowScrolling: 'touch',
														},
													},
												}}
												label="Ref Phy"
												inputProps={{ 'aria-label': 'Without label' }}
											>
											// <MenuItem value={0}>None</MenuItem> 
												{providers?.map((items, index) => {
													return (
														<MenuItem value={items?.id} key={index}>
															{items?.Lname + ',' + items?.Fname}
														</MenuItem>
													);
												})}
											</Select>
										</FormControl> */}
											<Autocomplete
												size="small"
												id="refphy-autocomplete"
												options={providers || []}
												getOptionLabel={(option) =>
													option ? `${option?.Lname}, ${option?.Fname}` : ''
												}
												sx={{ mt: 2 }}
												value={
													providers?.find(
														(item) => item?.id === patientStates?.refphy
													) || null
												}
												onChange={(event, newValue) => {
													handleChangePatientStates({
														target: {
															name: 'refphy',
															value: newValue ? newValue?.id : '',
														},
													});
												}}
												loading={loadingProviders}
												onOpen={handleProviderDropdownOpen}
												noOptionsText={
													loadingProviders ? (
														<Box
															display="flex"
															alignItems="center"
															gap={1}
															p={1}
														>
															<CircularProgress size={16} />
															<Typography fontSize={12}>Loading...</Typography>
														</Box>
													) : (
														'No options'
													)
												}
												ListboxProps={{
													style: {
														maxHeight: '160px',
													},
												}}
												renderInput={(params) => (
													<TextField
														{...params}
														label="Ref Phy"
														placeholder="Select referring physician"
														variant="outlined"
														error={errors.refphy}
														helperText={errors.refphy}
														sx={{
															'& .MuiOutlinedInput-root': {
																'&.Mui-focused fieldset': {
																	borderColor: '#0E6368',
																},
															},
														}}
													/>
												)}
											/>
											{/* Location */}
											<Autocomplete
												size="small"
												id="location-autocomplete"
												options={locationGet || []}
												getOptionLabel={(option) => option?.Name || ''}
												sx={{ mt: 2 }}
												value={
													locationGet?.find(
														(item) => item?.id === patientStates?.location
													) || null
												}
												onChange={(event, newValue) => {
													handleChangePatientStates({
														target: {
															name: 'location',
															value: newValue ? newValue?.id : '',
														},
													});
												}}
												loading={loadingLocation}
												onOpen={getLocationData}
												noOptionsText={
													loadingLocation ? (
														<Box
															display="flex"
															alignItems="center"
															gap={1}
															p={1}
														>
															<CircularProgress size={16} />
															<Typography fontSize={12}>Loading...</Typography>
														</Box>
													) : (
														'No options'
													)
												}
												ListboxProps={{
													style: {
														maxHeight: '160px',
													},
												}}
												renderInput={(params) => (
													<TextField
														{...params}
														label="Location"
														placeholder="Select location"
														variant="outlined"
														error={errors.location}
														helperText={errors.location}
														sx={{
															'& .MuiOutlinedInput-root': {
																'&.Mui-focused fieldset': {
																	borderColor: '#0E6368',
																},
															},
														}}
													/>
												)}
											/>
										</Grid>
										<Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
											<Grid
												container
												columnSpacing={2}
												rowSpacing={2}
												sx={{ marginBottom: '5px' }}
											>
												<Grid item xl={4} lg={4} md={4} sm={4} xs={4}>
													{/* <TextField
													fullWidth
													size="small"
													name="state"
													onChange={(e) => {
														handleChangePatientStates(e);
														Yup.reach(schema, 'state')
															.validate(e.target.value)
															.then(() => {
																setErrors((prevErrors) => ({
																	...prevErrors,
																	state: '',
																}));
															})
															.catch((error) => {
																setErrors((prevErrors) => ({
																	...prevErrors,
																	state: error.message,
																}));
															});
													}}
													label="State"
													variant="outlined"
												/> */}
													<Autocomplete
														fullWidth
														size="small"
														name="state"
														options={states}
														getOptionLabel={(option) => option?.name || ''}
														value={
															states.find(
																(state) => state?.code === patientStates?.state
															) || null
														}
														onChange={(event, newValue) => {
															handleChangePatientStates(newValue?.code || '');
															Yup.reach(schema, 'state')
																.validate(newValue ? newValue?.code : '')
																.then(() => {
																	setErrors((prevErrors) => ({
																		...prevErrors,
																		state: '',
																	}));
																})
																.catch((error) => {
																	setErrors((prevErrors) => ({
																		...prevErrors,
																		state: error.message,
																	}));
																});
														}}
														ListboxProps={{
															style: {
																maxHeight: '160px', // Set the height here
															},
														}}
														renderInput={(params) => (
															<TextField
																{...params}
																label="State"
																placeholder="Select state"
																variant="outlined"
																error={errors.state}
																helperText={errors.state}
																sx={{
																	'& .MuiOutlinedInput-root': {
																		'&.Mui-focused fieldset': {
																			borderColor: '#0E6368',
																		},
																	},
																}}
															/>
														)}
													/>
													{errors.state && (
														<div style={{ color: 'red', fontSize: '10px' }}>
															{errors.state}
														</div>
													)}
												</Grid>
												<Grid item xl={4} lg={4} md={4} sm={4} xs={4}>
													<TextField
														fullWidth
														size="small"
														name="city"
														value={patientStates?.city}
														onChange={(e) => {
															handleChangePatientStates(e);
															Yup.reach(schema, 'city')
																.validate(e.target.value)
																.then(() => {
																	setErrors((prevErrors) => ({
																		...prevErrors,
																		city: '',
																	}));
																})
																.catch((error) => {
																	setErrors((prevErrors) => ({
																		...prevErrors,
																		city: error.message,
																	}));
																});
														}}
														label="City"
														placeholder="Enter city"
														variant="outlined"
														autoComplete="off"
													/>
													{errors.city && (
														<div style={{ color: 'red', fontSize: '10px' }}>
															{errors.city}
														</div>
													)}
												</Grid>
												<Grid item xl={4} lg={4} md={4} sm={4} xs={4}>
													<TextField
														fullWidth
														size="small"
														name="zip"
														value={patientStates?.zip}
														onChange={(e) => {
															handleChangePatientStates(e);
															Yup.reach(schema, 'zip')
																.validate(e.target.value)
																.then(() => {
																	setErrors((prevErrors) => ({
																		...prevErrors,
																		zip: '',
																	}));
																})
																.catch((error) => {
																	setErrors((prevErrors) => ({
																		...prevErrors,
																		zip: error.message,
																	}));
																});
														}}
														label="Zip"
														placeholder="Enter zip code"
														variant="outlined"
														autoComplete="off"
													/>
													{errors.zip && (
														<div style={{ color: 'red', fontSize: '10px' }}>
															{errors.zip}
														</div>
													)}
												</Grid>
											</Grid>
										</Grid>
									</Grid>
								</Grid>
								{/* Care Team */}
								<Grid
									item
									xl={4}
									lg={4}
									md={12}
									sm={12}
									xs={12}
									sx={formSectionSx}
								>
									{renderFormSectionHeader(
										<GroupsOutlinedIcon fontSize="small" />,
										'Care Team'
									)}
									<Grid
										container
										item
										xl={12}
										lg={12}
										md={12}
										sm={12}
										xs={12}
										sx={formBodySx}
									>
										<Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
											<TextField
												sx={{
													marginTop: '.5rem',
												}}
												fullWidth
												size="small"
												name="cc"
												value={patientStates?.cc}
												onChange={(e) => {
													handleChangePatientStates(e);
													Yup.reach(schema, 'cc')
														.validate(e.target.value)
														.then(() => {
															setErrors((prevErrors) => ({
																...prevErrors,
																cc: '',
															}));
														})
														.catch((error) => {
															setErrors((prevErrors) => ({
																...prevErrors,
																cc: error.message,
															}));
														});
												}}
												label="Care Coordinator"
												placeholder="Enter care coordinator"
												variant="outlined"
												autoComplete="off"
											/>
											{errors.cc && (
												<div style={{ color: 'red', fontSize: '10px' }}>
													{errors.cc}
												</div>
											)}
										</Grid>
										<Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
											<TextField
												sx={{
													marginTop: '1rem',
												}}
												fullWidth
												size="small"
												name="ccr"
												value={patientStates?.ccr}
												onChange={(e) => {
													handleChangePatientStates(e);
													Yup.reach(schema, 'ccr')
														.validate(e.target.value)
														.then(() => {
															setErrors((prevErrors) => ({
																...prevErrors,
																ccr: '',
															}));
														})
														.catch((error) => {
															setErrors((prevErrors) => ({
																...prevErrors,
																ccr: error.message,
															}));
														});
												}}
												label="Care Coordinator Relation"
												placeholder="Select relation"
												variant="outlined"
												autoComplete="off"
											/>
											{errors.ccr && (
												<div style={{ color: 'red', fontSize: '10px' }}>
													{errors.ccr}
												</div>
											)}
										</Grid>
										<Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
											<TextField
												sx={{
													marginTop: '.8rem',
												}}
												fullWidth
												size="small"
												name="con"
												value={patientStates?.con}
												onChange={(e) => {
													handleChangePatientStates(e);
												}}
												InputProps={{
													endAdornment: (
														<InputAdornment position="start">
															<CallIcon sx={{ color: '#DDE6F1' }} />
														</InputAdornment>
													),
													inputComponent: MaskedInput,
													inputProps: {
														mask: [
															'(',
															/\d/,
															/\d/,
															/\d/,
															')',
															' ',
															/\d/,
															/\d/,
															/\d/,
															'-',
															/\d/,
															/\d/,
															/\d/,
															/\d/,
														],
													},
													sx: {
														borderRadius: '3px',
														height: '40px',
														'& .MuiOutlinedInput-input': {
															padding: '5px 0px 5px 6px',
														},
													},
												}}
												error={
													patientStates?.con != '' &&
													!isFilled(patientStates?.con)
												}
												helperText={
													patientStates?.con != '' &&
														!isFilled(patientStates?.con)
														? 'Please enter a valid phone number'
														: ''
												}
												label="Contact#"
												placeholder="Enter contact number"
												variant="outlined"
												autoComplete="off"
											/>
											{errors.con && (
												<div style={{ color: 'red', fontSize: '10px' }}>
													{errors.con}
												</div>
											)}
										</Grid>
										<Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
											<TextField
												sx={{
													marginTop: '.8rem',
												}}
												fullWidth
												size="small"
												multiline
												rows={3}
												name="cnotes"
												value={patientStates?.cnotes}
												onChange={(e) => {
													handleChangePatientStates(e);
													// Yup.reach(schema, 'cnotes')
													// 	.validate(e.target.value)
													// 	.then(() => {
													// 		setErrors((prevErrors) => ({
													// 			...prevErrors,
													// 			cnotes: '',
													// 		}));
													// 	})
													// 	.catch((error) => {
													// 		setErrors((prevErrors) => ({
													// 			...prevErrors,
													// 			cnotes: error.message,
													// 		}));
													// 	});
												}}
												label="Clinical Notes"
												placeholder="Enter clinical notes"
												variant="outlined"
												autoComplete="off"
											/>
											{errors.cnotes && (
												<div style={{ color: 'red', fontSize: '10px' }}>
													{errors.cnotes}
												</div>
											)}
										</Grid>
									</Grid>

									<Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
										<Box sx={{ px: '18px', pb: '18px' }}>
											<Typography
												sx={{
													fontSize: '15px',
													fontWeight: 700,
													fontFamily: 'Poppins',
													color: '#172d58',
													mb: '10px',
												}}
											>
												Attachments
											</Typography>
											<Box
												sx={{
													border: '1px dashed #b8d2f4',
													borderRadius: '8px',
													backgroundColor: '#fbfdff',
													minHeight: 56,
													display: 'flex',
													flexDirection: { xs: 'column', sm: 'row' },
													alignItems: 'center',
													justifyContent: 'center',
													textAlign: 'center',
													gap: { xs: 1, sm: 3 },
													px: { xs: 2, sm: 3 },
													py: { xs: 1.5, sm: 0.75 },
												}}
												onDragOver={(event) => {
													event.preventDefault();
												}}
												onDrop={(event) => {
													event.preventDefault();
													handleAttachmentFiles(event.dataTransfer.files);
												}}
											>
												<CloudUploadOutlinedIcon
													sx={{ color: '#2f6fd6', fontSize: 38, flexShrink: 0 }}
												/>
												<Typography
													sx={{
														fontFamily: 'Poppins',
														fontSize: '12px',
														fontWeight: 700,
														color: '#172d58',
														whiteSpace: 'nowrap',
													}}
												>
													Drag and drop files here
												</Typography>
												<Typography
													sx={{
														fontFamily: 'Poppins',
														fontSize: '12px',
														color: '#60739d',
														my: 0,
														whiteSpace: 'nowrap',
													}}
												>
													or
												</Typography>
												<Button
													variant="contained"
													component="label"
													size="small"
													sx={{
														background: '#2f6fd6',
														color: 'white',
														borderRadius: '6px',
														fontFamily: 'Poppins',
														fontSize: '11px',
														fontWeight: 700,
														height: 34,
														px: 2,
														boxShadow: '0 4px 10px rgba(47, 111, 214, 0.22)',
														'&:hover': {
															background: '#245fbd',
														},
													}}
												>
													<Box display={'flex'} alignItems={'center'} gap={1}>
														<AddIcon sx={{ fontSize: 18 }} />
														Select Files
													</Box>
													<input
														ref={fileInputRef}
														type="file"
														multiple
														style={{ display: 'none' }}
														onChange={(e) => {
															handleAttachmentFiles(e.target.files);
														}}
														accept=".pdf,.doc,.docx,.xls,.xlsx, .png, .jpg,.jpeg"
													/>
												</Button>
												<Typography
													sx={{
														fontFamily: 'Poppins',
														fontSize: '11px',
														color: '#7b8ba8',
														display: { xs: 'block', sm: 'none' },
													}}
												>
													Allowed file types: PDF, DOC, XLS, PNG, JPG
												</Typography>
											</Box>
										</Box>
										<Grid container>
											<Box sx={{ width: '100%' }}>
												{/* {dublicateFileSnack === true ? (
												<Box
													sx={{
														backgroundColor: '#0D406F',
														textAlign: 'center',
													}}
												>
													<span
														style={{
															color: 'white',
															fontWeight: '580',
															fontSize: '13px',
															fontFamily: 'Poppins',
														}}
													>
														This file already exist
													</span>
												</Box>
											) : (
												''
											)} */}
												{selectedFiles?.length > 0 && (
													<Box
														p={0}
														m={0}
														sx={{
															display: 'flex',
															flexDirection: 'column',
															padding: '8px',
															margin: '4px 12px 12px',
															height: {
																xl: '24vh',
																lg: '20vh',
																md: '20vh',
																sm: '20vh',
																xs: '20vh',
															},
															overflow: 'auto',
															border: '1px solid #e6edf7',
															borderRadius: '8px',
															backgroundColor: '#f8fbff',
														}}
													>
														{selectedFiles?.map((file, index) => (
															<>
																<Grid container>
																	<Grid
																		item
																		xl={11}
																		lg={11}
																		md={11}
																		sm={11}
																		xs={11}
																	>
																		<Box
																			key={index}
																			display="flex"
																			alignItems="center"
																			justifyContent={'space-between'}
																			sx={{
																				borderRadius: '8px',
																				background: '#EDFFF4',
																				fontSize: '12px',
																				padding: '5px',
																				margin: '5px',
																				border: '1px solid lightgray',
																			}}
																		>
																			<Typography
																				variant="body2"
																				sx={{
																					mr: 1,
																					fontSize: {
																						xl: '15px',
																						lg: '10px',
																						md: '9px',
																						sm: '9px',
																						xs: '9px',
																					},
																				}}
																			>
																				{file?.name}
																			</Typography>
																		</Box>
																	</Grid>
																	<Grid item xl={1} lg={1} md={1} sm={1} xs={1}>
																		<Box
																			sx={{
																				display: 'flex',
																			}}
																		>
																			<IconButton
																				size="small"
																				onClick={() => handleFileRemove(file)}
																				sx={{ border: '1px solid lightgray' }}
																			>
																				<CancelIcon
																					sx={{
																						fontSize: {
																							xl: '20px',
																							lg: '20px',
																							md: '18px',
																							sm: '20px',
																							xs: '20px',
																						},
																						color: 'red',
																					}}
																				/>
																			</IconButton>
																		</Box>
																	</Grid>
																</Grid>
															</>
														))}
													</Box>
												)}
											</Box>
										</Grid>
									</Grid>
								</Grid>

								{/* Insurance Info */}
								<Grid
									item
									xl={4}
									lg={4}
									md={12}
									sm={12}
									xs={12}
									sx={formSectionSx}
								>
									{renderFormSectionHeader(
										<HealthAndSafetyOutlinedIcon fontSize="small" />,
										'Insurance Information'
									)}
									{/* Data Grid Details */}
									{/* <Grid container spacing={2} padding={'5px 5px'}>
									<Grid item xs={12}>
										<Box
											sx={{
												height: '30vh',
											}}
										>
											<DataGrid
												rows={allInsuranceData}
												rowHeight={35}
												columnHeaderHeight={35}
												columns={InsuranceColumn}
												rowCount={allInsuranceData?.length}
												disableRowSelectionOnClick
												paginationModel={paginationModel}
												onPaginationModelChange={(e) => {
													setPaginationModel({
														page: e.page,
														pageSize: e.pageSize,
													});
													if (
														paginationModel.page != 0 &&
														paginationModel.pageSize === 10 &&
														paginationModel.page % 9 === 0
													) {
														setChangePage((prev) => {
															return {
																in_Page_Number: prev.in_Page_Number + 1,
																in_Rows: prev.in_Rows + 100,
															};
														});
													} else if (
														(paginationModel.page == 0 ||
															paginationModel.page !== 0) &&
														paginationModel.pageSize === 100
													) {
														setChangePage((prev) => {
															return {
																in_Page_Number: prev.in_Page_Number + 1,
																in_Rows: prev.in_Rows + 100,
															};
														});
													} else if (
														paginationModel.page != 0 &&
														paginationModel.pageSize === 25 &&
														paginationModel.page % 3 === 0
													) {
														setChangePage((prev) => {
															return {
																in_Page_Number: prev.in_Page_Number + 1,
																in_Rows: prev.in_Rows + 100,
															};
														});
													} else if (
														paginationModel.page != 0 &&
														paginationModel.pageSize === 50 &&
														paginationModel.page % 1 === 0
													) {
														setChangePage((prev) => {
															return {
																in_Page_Number: prev.in_Page_Number + 1,
																in_Rows: prev.in_Rows + 100,
															};
														});
													}
												}}
												pageSizeOptions={[5, 10, 25, 50, 100]}
												sx={{
													maxHeight: '40vh',
													'& .MuiDataGrid-columnHeader': {
														backgroundColor: '#2081B8',
														color: '#FFFFFF',
														fontFamily: 'Poppins',
														fontWeight: '300',
														fontSize: {
															xl: '15px',
															lg: '13px',
															md: '13px',
															sm: '13px',
															xs: '13px',
														},
														overflow: 'hidden',
														'.MuiSvgIcon-root': {
															color: 'white',
														},
													},
													'& .MuiDataGrid-footerContainer': {
														justifyContent: 'flex-start',
														backgroundColor: '#DCF0FF',
														height: '5px',
														fontSize: {
															xl: '15px',
															lg: '13px',
															md: '13px',
															sm: '13px',
															xs: '13px',
														},
													},

													'& .MuiInputBase-root': {
														border: '0.5px solid #383838',
														width: '60px',
														height: '30px',
														borderRadius: '10%',
														backgroundColor: 'white',
													},
													color: 'black',
													fontSize: {
														xs: '12px',
														sm: '12px',
														md: '12px',
														lg: '12px',
														xl: '14px',
													},
													'& .MuiDataGrid-virtualScroller': {
														overflowY: 'auto !important',
													},
													// '& .MuiTablePagination-displayedRows': {
													// 	display: 'none',
													// },
													'& .MuiTablePagination-selectLabel': {
														display: 'none',
													},
													// '& .MuiTablePagination-select': {
													// 	display: 'none',
													// },
													// '& .MuiTablePagination-selectIcon': {
													// 	display: 'none',
													// },
												}}
											/>{' '}
										</Box>
									</Grid>
								</Grid> */}

									<Grid
										container
										columnSpacing={1}
										rowSpacing={1}
										sx={formBodySx}
									>
										<Grid item xl={6} lg={6} md={6} sm={6} xs={12}>
											<TextField
												sx={{
													marginTop: '.5rem',
												}}
												fullWidth
												size="small"
												name="pname"
												value={patientStates?.pname}
												onChange={(e) => {
													handleChangePatientStates(e);
													Yup.reach(schema, 'pname')
														.validate(e.target.value)
														.then(() => {
															setErrors((prevErrors) => ({
																...prevErrors,
																pname: '',
															}));
														})
														.catch((error) => {
															setErrors((prevErrors) => ({
																...prevErrors,
																pname: error.message,
															}));
														});
												}}
												label="Plan Name"
												placeholder="Enter plan name"
												variant="outlined"
												autoComplete="off"
											/>
											{errors.pname && (
												<div style={{ color: 'red', fontSize: '10px' }}>
													{errors.pname}
												</div>
											)}
											<TextField
												sx={{
													marginTop: '15px',
												}}
												fullWidth
												size="small"
												name="gname"
												value={patientStates?.gname}
												onChange={(e) => {
													handleChangePatientStates(e);
													Yup.reach(schema, 'gname')
														.validate(e.target.value)
														.then(() => {
															setErrors((prevErrors) => ({
																...prevErrors,
																gname: '',
															}));
														})
														.catch((error) => {
															setErrors((prevErrors) => ({
																...prevErrors,
																gname: error.message,
															}));
														});
												}}
												label="Group Name"
												placeholder="Enter group name"
												variant="outlined"
												autoComplete="off"
											/>
											{errors.gname && (
												<div style={{ color: 'red', fontSize: '10px' }}>
													{errors.gname}
												</div>
											)}
										</Grid>
										<Grid item xs={6}>
											<Autocomplete
												size="small"
												id="insurance-autocomplete"
												options={insListName || []}
												getOptionLabel={(option) => option?.Name || ''}
												sx={{ mt: 1 }}
												value={
													insListName?.find(
														(item) => item?.id === patientStates?.iname
													) || null
												}
												onChange={(event, newValue) => {
													handleChangePatientStates({
														target: {
															name: 'iname',
															value: newValue ? newValue?.id : '',
														},
													});
												}}
												loading={loadingInsurance}
												// ✅ lazy load on open
												onOpen={handleInsuranceDropdownOpen}
												noOptionsText={
													loadingInsurance ? (
														<Box
															display="flex"
															alignItems="center"
															gap={1}
															p={1}
														>
															<CircularProgress size={16} />
															<Typography fontSize={12}>Loading...</Typography>
														</Box>
													) : (
														'No options'
													)
												}
												ListboxProps={{
													style: { maxHeight: '160px' },
												}}
												renderInput={(params) => (
													<TextField
														{...params}
														label="Insurance Name"
														placeholder="Select insurance"
														variant="outlined"
														error={errors.iname}
														helperText={errors.iname}
														sx={{
															'& .MuiOutlinedInput-root': {
																'&.Mui-focused fieldset': {
																	borderColor: '#0E6368',
																},
															},
														}}
													/>
												)}
											/>
											{patientStates?.iname && (
												<>
													<TextField
														sx={{
															marginTop: '15px',
															'& .MuiInputLabel-asterisk': {
																color: 'red',
															},
														}}
														fullWidth
														size="small"
														name="policy"
														value={patientStates?.policy}
														onChange={(e) => {
															handleChangePatientStates(e);
															Yup.reach(schema, 'policy')
																.validate(e.target.value)
																.then(() => {
																	setErrors((prevErrors) => ({
																		...prevErrors,
																		policy: '',
																	}));
																})
																.catch((error) => {
																	setErrors((prevErrors) => ({
																		...prevErrors,
																		policy: error.message,
																	}));
																});
														}}
														required
														label="Policy#"
														variant="outlined"
														autoComplete="off"
													/>
												</>
											)}
											{errors.policy && (
												<div style={{ color: 'red', fontSize: '10px' }}>
													{errors.policy}
												</div>
											)}
										</Grid>
									</Grid>
									{/* Add Multiple insurance section */}
									<Box
										display="flex"
										justifyContent="space-between"
										alignItems="center"
										sx={{
											borderTop: '1px solid #edf2f8',
											mt: 2,
											mx: '18px',
											pt: 2,
										}}
									>
										<Typography
											sx={{
												fontFamily: 'Poppins',
												fontSize: '15px',
												fontWeight: 700,
												color: '#172d58',
											}}
										>
											Additional Insurance
										</Typography>
										{/* Add Icon */}
										<Button
											variant="contained"
											component="label"
											startIcon={<AddCircleIcon sx={{ fontSize: '18px' }} />}
											size="small"
											disabled={
												patientStates?.fname && patientStates?.lname
													? false
													: true
											}
											sx={{
												background: '#2E68BA',
												whiteSpace: 'nowrap',
												color: 'white',
												borderRadius: '6px',
												height: 32,
												fontFamily: 'Poppins',
												fontSize: '11px',
												fontWeight: 700,
												boxShadow: '0 4px 10px rgba(46, 104, 186, 0.18)',
												'&:hover': {
													background: '#235ca8',
												},
												'&.Mui-disabled': {
													background: '#e5e7eb',
													color: '#9aa3af',
													boxShadow: 'none',
												},
											}}
											onClick={() => handleAddInsuranceForm()}
										>
											Add
										</Button>
									</Box>
									{insuranceForms?.length === 0 && (
										<Box
											sx={{
												display: 'flex',
												alignItems: 'center',
												gap: 1,
												mx: '18px',
												mt: 2,
												p: '12px',
												borderRadius: '6px',
												backgroundColor: '#f4f7fb',
												color: '#60739d',
											}}
										>
											<InfoOutlinedIcon
												sx={{ fontSize: 18, color: '#2f6fd6' }}
											/>
											<Typography
												sx={{
													fontFamily: 'Poppins',
													fontSize: '12px',
													fontWeight: 500,
												}}
											>
												Add additional insurance details if applicable.
											</Typography>
										</Box>
									)}
									<Box
										sx={{
											maxHeight: {
												xs: '100px',
												lg: '200px',
											},
											overflowY: 'auto',
											overflowX: 'hidden',
											padding: '16px 12px',
										}}
									>
										{insuranceForms?.map((form, index) => (
											<Badge
												badgeContent={
													<IconButton
														size="small"
														onClick={() => handleCloseInsuranceForm(index)}
														sx={{
															color: 'red',
															p: 0,
															mt: '8px',
															mr: '2.5rem',
														}}
													>
														<DoNotDisturbOnIcon fontSize="inherit" />
													</IconButton>
												}
												key={index}
											>
												<Grid
													container
													columnSpacing={1}
													rowSpacing={1}
													sx={{ padding: '10px 5px' }}
												>
													<Grid item xl={6} lg={6} md={6} sm={6} xs={12}>
														<TextField
															sx={{ marginTop: '.5rem' }}
															fullWidth
															size="small"
															name="planName"
															value={insuranceForms[index]?.planName}
															onChange={(e) => {
																const { name, value } = e.target;

																setInsuranceForms((prevForms) => {
																	const updatedForms = [...prevForms];
																	updatedForms[index] = {
																		...updatedForms[index],
																		[name]: value,
																	};
																	return updatedForms;
																});

																// Yup validation
																Yup.reach(singleInsuranceSchema, name)
																	.validate(value)
																	.then(() => {
																		setInsErrors((prevErrors) => {
																			const updatedErrors = [...prevErrors];
																			updatedErrors[index] = {
																				...updatedErrors[index],
																				[name]: '',
																			};
																			return updatedErrors;
																		});
																	})
																	.catch((error) => {
																		setInsErrors((prevErrors) => {
																			const updatedErrors = [...prevErrors];
																			updatedErrors[index] = {
																				...updatedErrors[index],
																				[name]: error.message,
																			};
																			return updatedErrors;
																		});
																	});
															}}
															label="Plan Name"
															variant="outlined"
															autoComplete="off"
														/>

														{insErrors[index]?.planName && (
															<>
																<Typography
																	variant="caption"
																	style={{
																		color: 'red',
																		fontSize: '10.5px',
																		padding: 0,
																	}}
																>
																	{insErrors[index]?.planName}
																</Typography>
															</>
														)}
														<TextField
															sx={{
																marginTop: '15px',
															}}
															fullWidth
															size="small"
															name="groupName"
															value={insuranceForms[index]?.groupName || ''}
															onChange={(e) => {
																const { name, value } = e.target;

																setInsuranceForms((prevForms) => {
																	const updatedForms = [...prevForms];
																	updatedForms[index] = {
																		...updatedForms[index],
																		[name]: value,
																	};
																	return updatedForms;
																});

																// Yup validation
																Yup.reach(singleInsuranceSchema, name)
																	.validate(value)
																	.then(() => {
																		setInsErrors((prevErrors) => {
																			const updatedErrors = [...prevErrors];
																			updatedErrors[index] = {
																				...updatedErrors[index],
																				[name]: '',
																			};
																			return updatedErrors;
																		});
																	})
																	.catch((error) => {
																		setInsErrors((prevErrors) => {
																			const updatedErrors = [...prevErrors];
																			updatedErrors[index] = {
																				...updatedErrors[index],
																				[name]: error.message,
																			};
																			return updatedErrors;
																		});
																	});
															}}
															label="Group Name"
															variant="outlined"
															autoComplete="off"
														/>
														{insErrors[index]?.groupName && (
															<div style={{ color: 'red', fontSize: '10px' }}>
																{insErrors[index]?.groupName}
															</div>
														)}
													</Grid>
													<Grid item xl={6} lg={6} md={6} sm={6} xs={6}>
														<FormControl
															fullWidth
															size="small"
															sx={{
																marginTop: '.5rem',
															}}
														>
															<InputLabel
																id="demo-simple-select-label"
																sx={{
																	fontSize: {
																		lg: '16px',
																		md: '13px',
																		sm: '16px',
																		xs: '16px',
																	},
																}}
															>
																Insurance Name
															</InputLabel>
															<Select
																labelId="demo-simple-select-label"
																id="demo-simple-select"
																name="insuranceName"
																value={
																	insuranceForms[index]?.insuranceName || ''
																}
																onChange={(e) => {
																	const { name, value } = e.target;

																	setInsuranceForms((prevForms) => {
																		const updatedForms = [...prevForms];
																		updatedForms[index] = {
																			...updatedForms[index],
																			[name]: value,
																		};
																		return updatedForms;
																	});
																}}
																MenuProps={{
																	PaperProps: {
																		style: {
																			maxHeight: '200px',
																			width: '130px',
																			overflowY: 'auto',
																			scrollbarWidth: 'thin',
																			scrollbarColor: 'dark',
																			msOverflowStyle: 'none',
																			WebkitOverflowScrolling: 'touch',
																		},
																	},
																}}
																label="Insurance Name"
																inputProps={{ 'aria-label': 'Without label' }}
															>
																<MenuItem value={''}>None</MenuItem>
																{insListName?.map((items, index) => {
																	return (
																		<MenuItem value={items?.id} key={index}>
																			{items?.Name}
																		</MenuItem>
																	);
																})}
															</Select>
														</FormControl>
														{form?.insuranceName && (
															<>
																<TextField
																	sx={{
																		marginTop: '15px',
																		'& .MuiInputLabel-asterisk': {
																			color: 'red',
																		},
																	}}
																	fullWidth
																	size="small"
																	name="policyNo"
																	value={insuranceForms[index]?.policyNo || ''}
																	onChange={(e) => {
																		const { name, value } = e.target;

																		setInsuranceForms((prevForms) => {
																			const updatedForms = [...prevForms];
																			updatedForms[index] = {
																				...updatedForms[index],
																				[name]: value,
																			};
																			return updatedForms;
																		});
																		// Yup validation
																		Yup.reach(singleInsuranceSchema, name)
																			.validate(value)
																			.then(() => {
																				setInsErrors((prevErrors) => {
																					const updatedErrors = [...prevErrors];
																					updatedErrors[index] = {
																						...updatedErrors[index],
																						[name]: '',
																					};
																					return updatedErrors;
																				});
																			})
																			.catch((error) => {
																				setInsErrors((prevErrors) => {
																					const updatedErrors = [...prevErrors];
																					updatedErrors[index] = {
																						...updatedErrors[index],
																						[name]: error.message,
																					};
																					return updatedErrors;
																				});
																			});
																	}}
																	required
																	label="Policy#"
																	variant="outlined"
																	autoComplete="off"
																/>
															</>
														)}
														{insErrors[index]?.policyNo && (
															<div style={{ color: 'red', fontSize: '10px' }}>
																{insErrors[index]?.policyNo}
															</div>
														)}
													</Grid>
												</Grid>
											</Badge>
										))}
									</Box>
								</Grid>
							</Grid>
						</Box>
						<Box
							sx={{
								display: 'flex',
								justifyContent: { xs: 'stretch', sm: 'flex-end' },
								alignItems: 'center',
								gap: '10px',
								flexWrap: 'wrap',
								py: { xs: 1, md: 0.5 },
								'& .MuiButton-root': {
									width: { xs: '100%', sm: 'auto' },
								},
							}}
						>
							<Button
								onClick={() => darkNavigate('/patient_list')}
								sx={{
									backgroundColor: '#fff',
									color: '#3f4652',
									borderColor: '#c8d3e1',
									fontSize: '12px',
									fontFamily: 'Poppins',
									fontWeight: 700,
									borderRadius: '6px',
									height: { xs: 32, md: 34 },
									px: 3,
									boxShadow: 'none',
									'&:hover': {
										backgroundColor: '#f7f9fc',
										borderColor: '#9aa8ba',
									},
								}}
								variant="outlined"
								size="large"
							>
								Cancel
							</Button>
							<Button
								sx={{
									backgroundColor: addSave ? '#E0E0E0' : '#2E68BA',
									fontSize: '12px',
									fontFamily: 'Poppins',
									fontWeight: 700,
									borderRadius: '6px',
									height: { xs: 32, md: 34 },
									px: 3,
									boxShadow: addSave
										? 'none'
										: '0 2px 6px rgba(46, 104, 186, 0.25)',
									'&:hover': {
										backgroundColor: addSave ? '#E0E0E0' : '#24589f',
									},
								}}
								onClick={buttonSubmit}
								variant="contained"
								size="large"
								disabled={addSave ? true : false}
							>
								Save
							</Button>
						</Box>
						{/* Snackbar for Save button */}

						<Snackbar
							open={openSnackbar}
							onClose={handleCloseSnackbar}
							anchorOrigin={{
								vertical: 'center',
								horizontal: 'center',
							}}
						>
							<Alert
								onClose={handleCloseSnackbar}
								severity="success"
								variant="filled"
								sx={{
									width: '100%',
									height: '4rem',
									textAlign: 'center',
									fontSize: '1.1rem',
									display: 'flex',
									justifyContent: 'center',
									alignItems: 'center',
								}}
								action={
									<React.Fragment>
										<span
											onClick={() => {
												darkNavigate('/patient_list');
											}}
											style={{
												cursor: 'pointer',
												m: 'auto 0',
												fontSize: '16px',
												color: 'rgb(231, 231, 231)',
											}}
										>
											Close
										</span>
									</React.Fragment>
								}
							>
								Patient Successfully Added !
							</Alert>
						</Snackbar>

						{/* Snackbar for Empty fields */}

						<Snackbar
							open={openEmptySnackbar}
							onClose={CancelEmptySnackbar}
							anchorOrigin={{
								vertical: 'center',
								horizontal: 'center',
							}}
						>
							<Alert
								onClose={CancelEmptySnackbar}
								severity="error"
								variant="filled"
								sx={{
									width: '100%',
									height: '4rem',
									textAlign: 'center',
									fontSize: '1.1rem',
									display: 'flex',
									justifyContent: 'center',
									alignItems: 'center',
								}}
								action={
									<React.Fragment>
										<span
											onClick={CancelEmptySnackbar}
											style={{
												cursor: 'pointer',
												m: 'auto 0',
												fontSize: '16px',
												color: 'rgb(231, 231, 231)',
											}}
										>
											Close
										</span>
									</React.Fragment>
								}
							>
								Must Fill All Fields !
							</Alert>
						</Snackbar>
						{/* Snackbar for Validation fields */}

						<Snackbar
							open={openValidateSnackbar}
							onClose={CancelEmptySnackbar}
							anchorOrigin={{
								vertical: 'center',
								horizontal: 'center',
							}}
						>
							<Alert
								onClose={CancelEmptySnackbar}
								severity="error"
								variant="filled"
								sx={{
									width: '100%',
									height: '4rem',
									textAlign: 'center',
									fontSize: '1.1rem',
									display: 'flex',
									justifyContent: 'center',
									alignItems: 'center',
								}}
								action={
									<React.Fragment>
										<span
											onClick={CancelEmptySnackbar}
											style={{
												cursor: 'pointer',
												m: 'auto 0',
												fontSize: '16px',
												color: 'rgb(231, 231, 231)',
											}}
										>
											Close
										</span>
									</React.Fragment>
								}
							>
								Must Validate All Fields !
							</Alert>
						</Snackbar>
						{/* Snackbar for Patient Already Exist */}

						<Snackbar
							open={openPatAlreadyExistSnackbar}
							onClose={CancelEmptySnackbar}
							anchorOrigin={{
								vertical: 'center',
								horizontal: 'center',
							}}
						>
							<Alert
								onClose={CancelEmptySnackbar}
								severity="error"
								variant="filled"
								sx={{
									width: '100%',
									height: '4rem',
									textAlign: 'center',
									fontSize: '1.1rem',
									display: 'flex',
									justifyContent: 'center',
									alignItems: 'center',
								}}
								action={
									<React.Fragment>
										<span
											onClick={CancelEmptySnackbar}
											style={{
												cursor: 'pointer',
												m: 'auto 0',
												fontSize: '16px',
												color: 'rgb(231, 231, 231)',
											}}
										>
											Close
										</span>
									</React.Fragment>
								}
							>
								Patient Already Exist !
							</Alert>
						</Snackbar>

					</>
				)}
			</Box>
			{/* <Modal
				open={duplicateModalOpen}
				onClose={() => setDuplicateModalOpen(false)}
				aria-labelledby="duplicate-modal-title"
				aria-describedby="duplicate-modal-description"
			>
				<Box
					sx={{
						position: 'absolute',
						top: '50%',
						left: '50%',
						transform: 'translate(-50%, -50%)',
						width: 400, // Slimmer table width
						bgcolor: 'background.paper',
						boxShadow: 24,
						p: 4,
						borderRadius: '8px',
					}}
				>
					<Typography
						id="duplicate-modal-title"
						variant="h6"
						component="h2"
						sx={{ mb: 2, textAlign: 'center', color: '#1976d2' }}
					>
						<h5>This Patient Name is Already Exists</h5>
					</Typography>
					<Typography
						id="duplicate-modal-description"
						sx={{ mb: 3, textAlign: 'center' }}
					>
						Do you want to add this patient again?
					</Typography>

					<Box
						sx={{
							border: '1px solid #ddd',
							borderRadius: '8px',
							overflow: 'hidden',
						}}
					>
						<TableContainer>
							<Table>
								<TableHead>
									<TableRow
										sx={{
											backgroundColor: '#1976d2',
											'& > th': {
												color: 'white',
												fontWeight: 'bold',
												textAlign: 'center',
												padding: '4px 8px',
												fontSize: '14px',
											},
										}}
									>
										<TableCell>First Name</TableCell>
										<TableCell>Last Name</TableCell>
									</TableRow>
								</TableHead>
								<TableBody>
									<TableRow
										sx={{
											'&:hover': { backgroundColor: '#f5f5f5' },
											'& > td': {
												textAlign: 'center',
												padding: '4px 8px',
												fontSize: '14px',
											},
										}}
									>
										<TableCell>{PatientData?.Fname || 'N/A'}</TableCell>
										<TableCell>{PatientData?.Lname || 'N/A'}</TableCell>
									</TableRow>
								</TableBody>
							</Table>
						</TableContainer>
					</Box>

					<Box
						sx={{ mt: 3, display: 'flex', justifyContent: 'end', gap: '5px' }}
					>
						<Button
							variant="outlined"
							color="error"
							onClick={() => setDuplicateModalOpen(false)}
						>
							No
						</Button>
						<Button
							variant="contained"
							color="primary"
							onClick={handleDuplicateConfirm}
						>
							Yes
						</Button>
					</Box>
				</Box>
			</Modal> */}
			<Modal
				open={duplicateModalOpen}
				onClose={() => setDuplicateModalOpen(false)}
				aria-labelledby="duplicate-modal-title"
				aria-describedby="duplicate-modal-description"
			>
				<Box
					sx={{
						position: 'absolute',
						top: '50%',
						left: '50%',
						transform: 'translate(-50%, -50%)',
						width: 500,
						bgcolor: 'background.paper',
						boxShadow: 24,
						p: 2,
						borderRadius: '8px',
					}}
				>
					<Grid container>
						<Grid item xl={11} lg={11} md={11} sm={11} xs={11} align="left">
							<Typography
								sx={{
									fontFamily: 'Poppins',
									fontWeight: '600',
									fontSize: '24px',
								}}
							>
								This Patient name is Already exist
								<span
									style={{
										fontFamily: 'Poppins',
										fontWeight: '600',
										fontSize: '16px',
										color: '#075AD7',
									}}
								></span>
							</Typography>
						</Grid>
						<Grid item xl={1} lg={1} md={1} sm={1} xs={1}>
							<CancelIcon
								sx={{
									fontSize: '24px',
									color: 'red',
									marginLeft: '1rem',
									cursor: 'pointer',
								}}
								onClick={() => setDuplicateModalOpen(false)}
							/>
						</Grid>
					</Grid>

					<Typography
						id="duplicate-modal-description"
						sx={{ mt: 1, mb: 2, textAlign: 'center' }}
					>
						<h5>Do you want to add this patient again?</h5>
					</Typography>

					<Box
						sx={{
							border: '1px solid #ddd',
							borderRadius: '8px',
							overflow: 'hidden',
							mb: 2,
						}}
					>
						<TableContainer>
							<Table>
								<TableHead>
									<TableRow
										sx={{
											backgroundColor: '#0D406F',
											'& > th': {
												color: 'white',
												fontWeight: '500',
												textAlign: 'center',
												padding: '4px 8px',
												fontSize: '12px',
											},
										}}
									>
										<TableCell>First Name</TableCell>
										<TableCell>Last Name</TableCell>
									</TableRow>
								</TableHead>
								<TableBody>
									<TableRow
										sx={{
											'& > td': {
												textAlign: 'center',
												padding: '4px 8px',
												fontSize: '11px',
											},
										}}
									>
										<TableCell>{PatientData?.Fname || 'N/A'}</TableCell>
										<TableCell>{PatientData?.Lname || 'N/A'}</TableCell>
									</TableRow>
								</TableBody>
							</Table>
						</TableContainer>
					</Box>

					<Box sx={{ display: 'flex', justifyContent: 'end', gap: '5px' }}>
						<Button
							variant="outlined"
							color="error"
							onClick={() => setDuplicateModalOpen(false)}
							sx={{ backgroundColor: '#ED2828', color: 'white' }}
						>
							No
						</Button>
						<Button
							variant="contained"
							color="primary"
							onClick={handleDuplicateConfirm}
							sx={{ backgroundColor: '#FD7702', color: 'white' }}
						>
							Yes
						</Button>
					</Box>
				</Box>
			</Modal>
		</>
	);
}

export default NewPatient;
